import React, { useEffect, useState } from 'react';
import {history} from "../utils/history";
import {ROUTERS_MAP} from "../utils/routes";
import {useDispatch} from "react-redux";
import {CheckTokenService, GetAuthCheck} from "../redux/actions";
import {Loader} from "../shared/features/Loader";
import {useLocation} from "react-router-dom";
import './PrivateRouteWrapper.scss';
import {PROFILE_CONSTS} from "../redux/constants";

const PrivateRouteWrapper = ({ children }) => {
    const dispatch = useDispatch();
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const locations = useLocation();

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await dispatch(CheckTokenService());
                dispatch({
                    type: PROFILE_CONSTS.GET_AUTH_CHECK,
                    payload: response.data
                })
                if (response.status === 200) {
                    setIsAuthenticated(true);
                } else {
                    setIsAuthenticated(false);
                    history.push(ROUTERS_MAP.LOGIN)
                }
            } catch (error) {
                console.error('Token check failed:', error);
                setIsAuthenticated(false);
                history.push(ROUTERS_MAP.LOGIN)
            }
        };

        checkAuth();
    }, [dispatch]);

    if (isAuthenticated === null) {
        return (
            <div className="main-page-container">
                <Loader size={150} />
            </div>
        );
    }

    if (!isAuthenticated) {
        return null; // Редирект уже произойдет в useEffect
    }

    return <>{children}</>;
};

export default PrivateRouteWrapper;